import { useState } from "react"
import { track } from "@/lib/analytics"
import { toast } from "sonner"
import { Button } from "@/components/ui/button"

export default function CopyShareLinkButton({
  videoId,
  size = "lg",
  iconOnly = false,
}: {
  videoId: string
  size?: "default" | "sm" | "lg" | "icon"
  iconOnly?: boolean
}) {
  const [copied, setCopied] = useState(false)

  function handleCopy() {
    const url = `${window.location.origin}/v/${videoId}`
    navigator.clipboard.writeText(url).then(() => {
      track("video_share_link_copied", { video_id: videoId })
      setCopied(true)
      toast.success("Share link copied to clipboard")
      setTimeout(() => setCopied(false), 2000)
    })
  }

  const icon = copied ? (
    <svg className={iconOnly ? "size-4" : "mr-2 size-4"} fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
    </svg>
  ) : (
    <svg className={iconOnly ? "size-4" : "mr-2 size-4"} fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
    </svg>
  )

  return (
    <Button variant="secondary" size={iconOnly ? "icon" : size} onClick={handleCopy}>
      {icon}
      {!iconOnly && (copied ? "Copied!" : "Copy share link")}
    </Button>
  )
}
